import {PlatformComponentContext} from 'src/components/platform-context/types';
import LaunchScreen from 'src/apps/mobile/pages/launch-screen/launch-screen';

const ionicContext: PlatformComponentContext = {
  LaunchScreen: LaunchScreen,
};

export default ionicContext;
